// extracted by mini-css-extract-plugin
export var brand = "_28-9";
export var compact = "_28-6";
export var extraSmall = "_28-7";
export var icon = "_28-0";
export var large = "_28-4";
export var light = "_28-1";
export var medium = "_28-5";
export var outline = "_28-b";
export var primaryDark = "_28-a";
export var primaryLight = "_28-8";
export var primaryModern = "_28-c";
export var success = "_28-2";
export var successSolid = "_28-3";